export default {
  apiBase: process.env.VUE_APP_API_ENDPOINT,
};
